import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=35c7f543&scoped=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=js"
export * from "./PeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=35c7f543&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7f543",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c7f543')) {
      api.createRecord('35c7f543', component.options)
    } else {
      api.reload('35c7f543', component.options)
    }
    module.hot.accept("./PeriodSelector.vue?vue&type=template&id=35c7f543&scoped=true", function () {
      api.rerender('35c7f543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/pricing/components/PeriodSelector.vue"
export default component.exports